import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {App} from './App';
import {SaneString} from './lib/Utils/SanePrimitives';

const root = document.getElementById('app');
const apiUrl = root ? SaneString(root.getAttribute('data-api-url')) : '';

ReactDOM.render(
  <App
    config={{
      apiUrl,
    }}
  />,
  root,
);
